<template>
  <div class="w-full">
    <div class="bg-ocean-950 text-center text-white pt-5 pb-6 space-y-2 rounded-b-xl px-standard">
      <h1
        class="text-3xl leading-8 font-title"
        v-html="$t('search.talk-to-a-veterinarian-html')"
      />
      <p class="leading-6">
        {{ $t('search.tell-us-about-your-pet-and-we-will-recommend') }}
      </p>
    </div>
    <div class="py-12 mx-auto max-w-2xl w-full px-standard space-y-10">
      <div class="space-y-4 lg:space-y-8">
        <div class="space-y-2">
          <h2 class="text-xl lg:text-2xl leading-6 font-medium">
            {{ $t('search.where-are-you-located') }}
          </h2>
          <p class="text-sm lg:text-base">
            {{ $t('search.well-do-our-best-to-find-your-pet-a-vet-nearby') }}
          </p>
        </div>
        <vetster-location-search
          :show-label="false"
          :locale="locale"
          :countries="country"
          class="w-full"
          @location-selected="handleLocationSelected"
        />
      </div>
      <div
        v-if="hasSpeciesTreated"
        class="space-y-4 lg:space-y-8"
      >
        <div class="space-y-2">
          <h2 class="text-xl lg:text-2xl leading-6 font-medium">
            {{ $t('search.who-is-the-appointment-for') }}
          </h2>
          <p class="text-sm lg:text-base">
            {{ $t('search.please-tell-us-your-pets-species') }}
          </p>
        </div>
        <vetster-show-client-pets
          v-if="hasUser && isClient && hasPets"
          :show-label="false"
        />
        <vetster-show-pet-species
          v-else
          :show-label="false"
        />
      </div>
      <vetster-button
        variant="ocean"
        :is-loading="loading"
        class="w-full lg:w-auto lg:mx-auto"
        @click="$emit('filter-and-search')"
      >
        {{ $t('search.find-my-vet') }}
      </vetster-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import VetsterLocationSearch from '@/brand-components/GuidedSearch/VetsterLocationSearch';
import VetsterShowPetSpecies from '@/brand-components/GuidedSearch/VetsterShowPetSpecies';
import VetsterShowClientPets from '@/brand-components/VetsterShowClientPets';

export default {
  name: 'VetsterRecommendVet',

  components: {
    VetsterLocationSearch,
    VetsterShowClientPets,
    VetsterShowPetSpecies,
  },

  props: {
    country: {
      type: String,
      required: true,
    },
    locale: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters([
      'hasUser',
      'isClient',
    ]),
    ...mapGetters('pets', ['hasPets']),
    ...mapGetters('search', ['hasSpeciesTreated']),
  },

  methods: {
    handleLocationSelected(data) {
      this.$emit('location-selected', data);
    },
  },
};
</script>
